export default __webpack_public_path__ + "static/media/dashboard.4824daf7.svg";